import { Card, IconButton } from '@nike/eds'
import { useState } from 'react'

import './SilhouetteCallout.scss'

interface SilhouetteCalloutProps {
  message: string
  onDismiss?: () => void
}

export const SilhouetteCallout = ({
  message,
  onDismiss
}: SilhouetteCalloutProps) => {
  const [visible, setVisible] = useState(true)

  if (!visible) return null

  const handleDismiss = () => {
    setVisible(false)
    onDismiss?.()
  }

  return (
    <Card className="silhouette-callout-card" data-testid="silhouette-callout">
      <div className="silhouette-callout-content">
        <div className="silhouette-callout-text">
          <p className="silhouette-callout-message">{message}</p>
        </div>
        <IconButton
          label="Dismiss"
          variant="ghost"
          size="medium"
          icon="Close"
          onClick={handleDismiss}
        />
      </div>
    </Card>
  )
}
